import { atomWithStorage } from 'jotai/utils';

export const sidebarStateAtom = atomWithStorage<'expanded' | 'collapsed' | 'floating'>(
  'sidebar_state',
  'expanded',
);

export const SIDEBAR_MIN_WIDTH = 200;
export const SIDEBAR_MAX_WIDTH = 300;
export const SIDEBAR_DEFAULT_WIDTH = 230;

export const sidebarWidthAtom = atomWithStorage<number>('sidebar_width', SIDEBAR_DEFAULT_WIDTH);

export const sidebarClosedSectionsAtom = atomWithStorage<string[]>('sidebar_closed_sections', []);
